import { formatDateTimeOrDash } from '#/utils/date';

/** 盤點無 status／workflow；SideMsg 僅摘要欄位。 */
export const stocktakeSideMsgDetailBlock = {
  fields: [
    { label: '盤點單號', value: 'stocktakeNo' },
    { label: '項目數', value: 'lineCount' },
    { label: '備註', value: 'remark' },
    {
      label: '建立時間',
      value: (row) => formatDateTimeOrDash(row?.record?.createdAt),
    },
    {
      label: '更新時間',
      value: (row) => formatDateTimeOrDash(row?.record?.updatedAt),
    },
  ],
};

export const stocktakeSideMsgBlocks = [stocktakeSideMsgDetailBlock];
